import React from 'react';

class NextArrow extends React.Component {
  render() {
    const {size, className, style, onClick} = this.props;
    return (
        <img
            className={className}
            style={{...style, display: 'block', width: size, height: size}}
            onClick={onClick}
            src={'https://copy-medcampus.s3.ap-south-1.amazonaws.com/wp-content/uploads/2019/05/09190052/iconfinder_arrow-right-01_186409.png'}
            alt={'Next arrow'}
        />
    );
  }
}

export default NextArrow;
